import { Button, PageHeader } from '@my/ui';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

/**
 * Walk-around checks list — placeholder. Replace the empty-state card with a
 * real, filterable table of recorded checks once `@my/safety-api` exposes the
 * list endpoint + hook.
 */
export function CheckListPage() {
  const { t } = useTranslation('checks');
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <PageHeader title={t('list.title')} description={t('list.description')}>
        <Button onClick={() => navigate('/checks/new')}>
          <Plus className="h-4 w-4" />
          {t('list.add')}
        </Button>
      </PageHeader>
      <section className="mt-6 rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
        <p className="text-sm text-slate-500">{t('list.comingSoon')}</p>
      </section>
    </div>
  );
}
